<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-default v-bind:title="$t('save')" ref="thisModal" v-bind:oncancel="discardChanges" v-bind:onsave="doSave">
      <div class="form-group">
        <div class="row">
          <div class="col-sm-12">
            {{ $t('you_have_made_chages_save_question') }}
          </div>
        </div>
      </div>
    </modal-default>
  </div>

</template>

<script>

  var sendClosable = false;

  import ModalThreeButtons from "../modals/modal-three-buttons.vue";
  export default {
    name: "procedure-save",
    components: {
      ModalThreeButtons
    },
    props: {
      isClone: {
        required: false,
        type: Boolean,
        default: false
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        sendClosable
      };
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 18");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    methods: {

      open() {
        this.$refs.thisModal.open();
      },
      async doSaveAndAssign() {       
        await this.doSave();
        this.$root.$emit("open_assign", this.scheduleid);

        //if (this.isClone === false) {
          
        //}
      },
      discardChanges() {
        this.$store.commit('discardChanges');
        this.$root.$emit('procedure_editor_can_close');
        //this.$refs.thisModal.close();
        //vm.$root.$emit('procedure_editor_can_close');
        
      },
      doSaveCopy() {
        this.isClone = true;
        doSave();
      },
      async doSave() {
        if (this.procedure.ProcedureId != 0) {
          await this.saveExistingProcedure();
        }
        else {
          await this.saveNewProcedure();
        }
        this.$emit('procedure_saved');
      },

      async saveNewProcedure() {
        
        var tmpProcedure = { name: this.procedure.ProcedureName, istask: this.procedure.IsTask };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);
        
        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('doSearch');
            var proc = thisContext.procedure;
            proc.ProcedureId = response.data.Id;
            proc.CategoryId = 1;
            this.scheduleid = response.data.ProcedureScheduleId;
            thisContext.procedure = proc;
            thisContext.saveExistingProcedure();
            

            //var proc = JSON.parse(JSON.stringify(thisContext.procedure));
            //this.scheduleid = response.data.ProcedureScheduleId;
            //proc.ProcedureId = response.data.ProcedureId;
            //proc.CategoryId = 1;
            //this.$store.commit('loadnewProcedure', proc);
            //thisContext.$root.$emit('doSearch');
          });
      },

      async saveExistingProcedure() {
        //var request = this.procedure;        
        var request = {
          procedureViewModel: this.procedure,         
        };
        //alert('sending:' + JSON.stringify(this.procedure))

        try {

          if (this.isClone == true) {

            alert('ooops')
            /* Not used anymore... I think

            var request = {
              procedureId: request.ProcedureId,
              name: request.ProcedureName,
              description: "",
              istask: true,
              locationId: null,              
              date: null,//proc.Datescheduled,
              userName: this.assignedUser,
              ProcedureScheduleId: this.scheduleid,
              EstimatedTime: request.EstimatedTime,
              isGlobal: request.isGlobal,
            };

            

            var response = await this.$http.post(
              '/api/Procedure/CloneProcedure',
              request,
              {
                headers: {
                  'Content-Type': 'application/json',
                  "Accept": "application/json"
                }
              }
            ).then(async response => {              
              this.$store.commit('loadnewProcedure', response.data)
              this.$emit("open_assign");
              //alert('doSearch9')
              vm.$root.$emit('doSearch');
            });

            */

          } else {
            var response = await this.$http.put(
              '/api/Procedures/v1/UpdateProcedure',
              request,
              {
                headers: {
                  'Content-Type': 'application/json',
                  "Accept": "application/json"
                }
              }
            )
              .then(async response => {
                //alert('doSearch10')
                vm.$root.$emit('doSearch');

                var proc = JSON.parse(JSON.stringify(this.procedure));
                proc.ProcedureId = response.data.ProcedureId;
                proc.CategoryId = response.data.CategoryId
                proc.Description = response.data.Description;
                proc.ProcedureName = response.data.ProcedureName;

                this.$store.commit('loadnewProcedure', proc);
              });
          }
        } catch (err) {
        }

        this.$refs.thisModal.close();
        if (this.sendClosable == true) {
          vm.$root.$emit('procedure_editor_can_close');
        }
      },

      handleRefresh(val) {
        //if (this.originalProcedure == "")
        //  this.originalProcedure = JSON.stringify(this.procedure);
        this.$forceUpdate();
      },
      openAndDoClosable() {
        this.sendClosable = true;
       
        this.open();
      }
    },
    mounted() {

    },
    created: function () {

    },
    watch: {

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-save.vue